// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:768px){.page[data-v-45612c08]{grid-template-columns:repeat(1,minmax(0,1fr))}}", ""]);
// Exports
module.exports = exports;
